import { BASE_URL } from '../../../utils/constants/url-constants';
import type { ResourceHubLocale } from '../../../types/resource-hub';
import type { TrilingualEmbedArticleSeo } from './trilingual-embed-articles-seo';

/** Absolute URLs for canonical + hreflang cluster (en / fi / sv + x-default → English). */
export type TrilingualEmbedHreflangCluster = {
  canonicalUrl: string;
  enUrl: string;
  fiUrl: string;
  svUrl: string;
  /** Always the English URL — JobCrawls x-default convention. */
  xDefaultUrl: string;
};

/**
 * Builds canonical and alternate URLs for one locale of a trilingual embed article.
 * Use the same base URL everywhere (staging, prod) via {@link BASE_URL}.
 */
export function getTrilingualEmbedHreflangCluster(
  article: TrilingualEmbedArticleSeo,
  locale: ResourceHubLocale,
  baseUrl: string = BASE_URL,
): TrilingualEmbedHreflangCluster {
  const enUrl = `${baseUrl}${article.en.path}`;
  const fiUrl = `${baseUrl}${article.fi.path}`;
  const svUrl = `${baseUrl}${article.sv.path}`;
  const canonicalUrl = `${baseUrl}${article[locale].path}`;
  return {
    canonicalUrl,
    enUrl,
    fiUrl,
    svUrl,
    xDefaultUrl: enUrl,
  };
}

/** Hub card `href` record — single source of truth with page heads. */
export function trilingualEmbedHubHref(
  article: TrilingualEmbedArticleSeo,
): Record<ResourceHubLocale, string> {
  return {
    en: article.en.path,
    fi: article.fi.path,
    sv: article.sv.path,
  };
}
